/* Lavender Farm Simulator — land on the playable part when a work area opens.
   Pressing Farm Map, Lavender Field, Greenhouse, Flower Farm or Apiary used to leave the player at the
   tab row, with the actual map / beds / hives several screens further down. Now, once the area has
   drawn, the page glides so the tool belt and the playable grid sit just under the sticky farm bar.
   Also keeps each tool belt pinned just below that sticky bar instead of hiding behind it.
   Only moves after a real press (tab, map landmark, "Open" button); if the player scrolls while the area
   loads, it leaves them where they are. Doesn't change how tabs or the top menu look; never edits the save. */
(function () {
  'use strict';
  if (window.__gllfSimTabJump) return;
  window.__gllfSimTabJump = true;

  /* what counts as "playable" in each area, best first */
  var PLAY = {
    world: ['.gllf-belt--map', '.lfg-world-map-card', '.lfg-world-map'],
    field: ['.lfg-field-card', '#lfg-field'],
    greenhouse: ['.gws-belt', '.lfg-gh-beds', '[data-gh-bed]'],
    cutflower: ['.gllf-belt', '.gws-cf-grid', '[data-cf-bed]'],
    apiary: ['.gllf-belt--apiary', '[data-apiary-hive-card]']
  };
  var GAP = 10, WAIT_MAX = 9000;
  var lastPress = 0, job = null;

  function root() { return document.getElementById('lfg-simulator-root'); }
  function reduced() { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; }

  /* height of the farm bar + hub tabs that stay stuck to the top of the screen */
  function stickyTop() {
    var r = root(); if (!r) return 0;
    var m = 0;
    r.querySelectorAll('.lfg-farm-pulse, nav.lfg-hubs, .lfg-tabs.lfg-hubs').forEach(function (e) {
      var cs = getComputedStyle(e);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && e.offsetHeight && cs.display !== 'none') {
        m = Math.max(m, (parseFloat(cs.top) || 0) + e.offsetHeight);
      }
    });
    return Math.min(m, window.innerHeight * 0.45);
  }
  function pinBelts() {
    var r = root(); if (!r) return;
    var v = Math.round(stickyTop() + 8) + 'px';
    if (r.style.getPropertyValue('--gllf-sticky-top') !== v) r.style.setProperty('--gllf-sticky-top', v);
  }

  function target(route) {
    var r = root(), v = r && r.querySelector('#lfg-view-' + route);
    if (!v || v.hidden || !v.offsetParent) return null;
    var list = PLAY[route];
    for (var i = 0; i < list.length; i++) {
      var el = v.querySelector(list[i]);
      if (el && el.offsetParent && el.getBoundingClientRect().height > 20) return el;
    }
    return null;
  }

  function jump(el) {
    var top = window.scrollY + el.getBoundingClientRect().top - stickyTop() - GAP;
    if (Math.abs(top - window.scrollY) < 24) return;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced() ? 'auto' : 'smooth' });
  }

  function cancelJob() { if (job) { cancelAnimationFrame(job.raf); job = null; } }
  function queue(route) {
    cancelJob();
    if (!PLAY[route]) return;
    var j = job = { route: route, t0: Date.now(), y0: window.scrollY };
    (function loop() {
      if (job !== j) return;
      if (Date.now() - j.t0 > WAIT_MAX) { job = null; return; }
      var c = document.getElementById('lfg-action-coach-lfg-simulator-root');
      var ct = c && !c.hidden && c.getClientRects().length ? c.textContent : '';
      if (j.c0 === undefined) j.c0 = ct;
      if (ct !== j.c0 && /didn.t run/i.test(ct)) { job = null; return; }
      var el = target(route);
      if (el) {
        /* two frames so the area has painted and its height has settled */
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          if (job !== j) return; job = null; pinBelts(); jump(el);
        }); });
        return;
      }
      j.raf = requestAnimationFrame(loop);
    })();
  }

  /* remember real presses so automatic route changes (saves, tours) don't move the page */
  ['pointerup', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (ev === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      var r = root(); if (r && r.contains(e.target)) lastPress = Date.now();
    }, true);
  });
  /* the player scrolling on their own while an area loads wins */
  ['wheel', 'touchmove'].forEach(function (ev) {
    window.addEventListener(ev, function () { if (job && Date.now() - job.t0 > 150) cancelJob(); }, { passive: true });
  });
  window.addEventListener('keydown', function (e) {
    if (job && /^(ArrowUp|ArrowDown|PageUp|PageDown|Home|End)$/.test(e.key)) cancelJob();
  }, true);

  document.addEventListener('lfg:route-enter', function (e) {
    var d = e.detail || {};
    if (!d.route || Date.now() - lastPress > 1500) return;
    if (window.__gllfTabResync && Date.now() - window.__gllfTabResync < 400) return; /* highlight re-sync, not a player move */
    queue(d.route);
  }, true);
  /* pressing the tab of the area you're already in also brings the playable part back into view */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-tab]');
    var r = root(); if (!t || !r || !r.contains(t)) return;
    var route = t.getAttribute('data-tab');
    if (PLAY[route] && t.getAttribute('aria-selected') === 'true') setTimeout(function () { queue(route); }, 0);
  }, true);

  window.addEventListener('resize', pinBelts);
  var tries = 0;
  (function wait() {
    if (root()) { pinBelts(); setInterval(pinBelts, 2000); return; }
    if (++tries < 240) setTimeout(wait, 250);
  })();
})();
